<template>
  <div class="modal__complete-body">
    <div>
      <img
        :src="okImg"
        alt=""
      >
    </div>
    <p class="success__message">
      {{ message || 'Success' }}
    </p>
  </div>
</template>

<script>
import okImg from '@/assets/theme/icon/ok.svg';

export default {
  props: ['message'],
  computed: {
    okImg: () => okImg,
  },
};

</script>

<style lang="scss" scoped>
  .modal__complete-body{
    text-align: center;
    .success__message{
      text-align: center;
      margin-top: 20px;
    }
  }
</style>
